/**
 * hw-card background video click-to-pause.
 *
 * Wraps the hw-video (deferred-media) render inside hw-card when the
 * merchant enables click-to-play. After the poster click swaps the
 * <video> into the DOM, clicks on the video toggle play/pause. The
 * handler stops propagation so the card link underneath never fires.
 *
 * Uses delegated listening on the wrapper so the dynamically inserted
 * <video> is covered without needing a MutationObserver.
 */
class HwCardBgVideo extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  /**
   * @param {MouseEvent} event
   */
  #handleClick = (event) => {
    const target = /** @type {Element | null} */ (event.target);
    const video = target?.closest?.('video');

    if (!(video instanceof HTMLVideoElement) || !this.contains(video)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (video.paused) {
      video.play().catch(() => {});
      return;
    }

    video.pause();
  };
}

if (!customElements.get('hw-card-bg-video')) {
  customElements.define('hw-card-bg-video', HwCardBgVideo);
}
